import { c as _c } from "react/compiler-runtime";
import { Details } from '@cc-shopping/ui/primitives/Details';
import { palette } from '@cc-shopping/ui/theme';
import { Box, List, Typography } from '@mui/material';
import { useId } from 'react';
export function Accordion(t0) {
  const $ = _c(20);
  const {
    title,
    children
  } = t0;
  const titleId = useId();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      margin: 0
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      color: "text.secondary",
      fontSize: 14,
      fontWeight: 500
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== title || $[3] !== titleId) {
    t3 = <Typography component="span" id={titleId} sx={t2}>{title}</Typography>;
    $[2] = title;
    $[3] = titleId;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="mask-icon mask-icon-expand-more expand-icon" aria-hidden="true" style={{
      width: "20px",
      height: "20px",
      backgroundColor: palette.neutral.dark
    }} />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3) {
    t5 = <Box sx={t1} gap="1.5rem">{t3}{t4}</Box>;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      sx: {
        paddingY: 2,
        paddingX: 3,
        borderBottom: "1px solid",
        borderColor: "neutral.lighter"
      }
    };
    t7 = {
      open: true
    };
    $[8] = t6;
    $[9] = t7;
  } else {
    t6 = $[8];
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      margin: 0,
      padding: 0
    };
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      paddingY: 0
    };
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== children) {
    t10 = <List sx={t9}>{children}</List>;
    $[12] = children;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== titleId) {
    t11 = <Box component="fieldset" aria-labelledby={titleId} sx={t8}>{t10}</Box>;
    $[14] = t10;
    $[15] = titleId;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t11 || $[18] !== t5) {
    t12 = <Details variant="simple" SummaryComponent={t5} summaryComponentProps={t6} detailsProps={t7}>{t11}</Details>;
    $[17] = t11;
    $[18] = t5;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  return t12;
}